import React from 'react';
import CompactList from '../CompactList';
import PropTypes from 'prop-types';

export const RecommendTripPathList = ({ recommendationData, listItemCallback, eventName }) => {
  const { title = '', list = [] } = { ...recommendationData };
  if (!list.length) {
    return null;
  }
  return (
    <CompactList className="rightMargin" title={title} list={list} eventName={eventName}>
      {listItemCallback}
    </CompactList>
  );
};

export const RecommendTripPathWrapper = ({ recommendPaths }) =>
  recommendPaths &&
  recommendPaths.map(({ recommendPathData, callbackToDisplayListItem, eventName }, index) => (
    <RecommendTripPathList
      recommendationData={recommendPathData}
      listItemCallback={callbackToDisplayListItem}
      key={index}
      eventName={eventName}
    />
  ));

RecommendTripPathList.propTypes = {
  recommendationData: PropTypes.object,
  listItemCallback: PropTypes.func,
  eventName: PropTypes.string
};

export default RecommendTripPathWrapper;
